import { DropIndicator } from "app/components/DropIndicator";
import clsx from "clsx";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { actions } from "../../../../redux/slice";
import RowCustomize from "../../TicketFields/RowCustomize";
import { ITickets } from "../../types";
import RowFirstCol from "./RowFirstCol";
import { RowProps } from "./types";
import { useCardDragDrop } from "../../../../components/ticketDragHook";

export const Row: React.FC<RowProps> = ({
  ticket,
  index,
  group,
  gridTemplate,
  minTableWidth,
  cols,
  selectedTickets,
  projectId,
}) => {
  // const ticketRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useDispatch();

  const isSelected = selectedTickets?.id?.includes(ticket._id);

  // ✅ selectedTickets ko ref mein rakho — drag re-register na ho selection change pe
  const selRef = useRef(selectedTickets);
  React.useEffect(() => {
    selRef.current = selectedTickets;
  }, [selectedTickets]);

  const handleToggleSelection = (ticket: ITickets) => {
    dispatch(actions.toggleSelectTicket({ group: group, ticket: ticket }));
  };

  const { ticketRef, closestEdge } = useCardDragDrop({
    ticket,
    group,
  });

  return (
    <div
      ref={ticketRef}
      className={clsx(
        "grid items-center min-h-[36px] h-[36px] border-b border-gray-100 hover:bg-gray-200 group bg-white relative",
        isSelected && "!bg-primary50",
      )}
      style={{ gridTemplateColumns: gridTemplate, minWidth: minTableWidth }}
    >
      {closestEdge === "top" && <DropIndicator edge="top" gap="12px" />}

      <RowFirstCol
        ticket={ticket}
        isSelected={isSelected}
        onCheckboxClick={handleToggleSelection}
        projectId={projectId}
      />

      <RowCustomize
        header={cols}
        ticket={ticket}
        projectId={projectId}
        isSelected={isSelected}
      />

      {closestEdge === "bottom" && <DropIndicator edge="bottom" gap="12px" />}
    </div>
  );
};
